export const OPEN_AI_ORGANISATION_ID_RECORD: Record<string, string> = {
  "org-6iFHRmwgxNFss0T5gkCWh8qY": "V0",
  "org-DpElRINV4DQBz9sFipUK5zc4": "V1",
};
